import React from 'react';
import { ICON } from '../theme';

/**
 * A Material Symbols Rounded icon, by name (e.g. "group"), weight 400 and
 * outlined (FILL 0). `fill` is only for the active nav item and active tab
 * (kit §3 Icons). Hidden from screen readers: buttons carry the words.
 */
export const Icon = ({ name, size = 20, color, style, fill }: {
  name: string;
  size?: number;
  color?: string;
  style?: React.CSSProperties;
  fill?: boolean;
}) => (
  <span
    aria-hidden="true"
    style={{
      fontFamily: ICON,
      fontSize: size,
      lineHeight: 1,
      flex: 'none',
      color,
      userSelect: 'none',
      fontWeight: 'normal',
      fontVariationSettings: `'FILL' ${fill ? 1 : 0}, 'wght' 400`,
      ...style,
    }}
  >
    {name}
  </span>
);
